import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

window.lightbox = new PhotoSwipeLightbox({
  gallery: '.wp-block-project-content',
  children: 'figure > a',
  showAnimationDuration: 500,
  hideAnimationDuration: 500,
  pswpModule: () => import('photoswipe'),
  padding: { top: 30, bottom: 30, left: 30, right: 30 },
});

window.lightbox.init();
